<template>
  <molecule-card>
    <atom-badge :type="isActive ? 'success' : 'danger'">
      {{ formattedStatus }}
    </atom-badge>
    <span class="extra-info">Created by {{ getCreatedByUserDisplayName }}</span>
    <ion-data-items group-size="three">
      <ion-data-item item-key="Token">
        ************{{ token.last4DigitToken }}
      </ion-data-item>
      <ion-data-item item-key="Issue date">
        {{ token.issueDate.formatted("DD MMM YYYY") }}
      </ion-data-item>
      <ion-data-item item-key="Last used">
        {{ lastUsedPhrase }}
      </ion-data-item>
      <ion-data-item v-if="!isActive" item-key="Revoked date">
        {{ token.deactivatedAt?.formatted() }}
      </ion-data-item>
    </ion-data-items>
    <div class="content-actions">
      <atom-button v-if="isActive" size="small" icon="bin" type="link-button" @click="revokeToken">
        Revoke
      </atom-button>
    </div>
  </molecule-card>
</template>

<script lang="ts">
import type { JsonScimToken } from "authentication/js/api/scim-tokens.api";
import type { PropType } from "vue";
import AtomBadge from "core/components/atom/badge/AtomBadge.vue";
import AtomButton from "core/components/atom/button/AtomButton.vue";
import IonDataItem from "core/components/ion/dataitems/IonDataItem.vue";
import IonDataItems from "core/components/ion/dataitems/IonDataItems.vue";
import MoleculeCard from "core/components/molecule/card/MoleculeCard.vue";
import { capitalizeFirstLetter } from "core/js/string-utils";
import { useUserStore } from "core/store/user.store";
import { defineComponent } from "vue";

export default defineComponent({
  components: { IonDataItem, IonDataItems, AtomBadge, MoleculeCard, AtomButton },
  props: {
    token: {
      type: Object as PropType<JsonScimToken>,
      required: true,
    },
  },
  setup() {
    return {
      userStore: useUserStore(),
    };
  },
  computed: {
    isActive() {
      return this.token.status === "ACTIVE";
    },
    lastUsedPhrase() {
      return this.token.lastUsedAt?.formatted() || "Not used yet";
    },
    formattedStatus() {
      return capitalizeFirstLetter(this.token.status.toLocaleLowerCase());
    },
    getCreatedByUserDisplayName() {
      return this.userStore.getUserDisplayNameOrDefault(this.token.createdByUserId);
    },
  },
  methods: {
    revokeToken() {
    },
  },
});
</script>

<style scoped lang="scss">
.content-actions {
  border: none;
}
</style>
